var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRapid = function SvgRapid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "rapid_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      masktype: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#rapid_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.952 15.616q.729-.04 1.063-.524L18.27 7.77l-7.361 5.216q-.502.334-.559 1.038-.057.705.409 1.17t1.194.423M12 5q1.38 0 2.51.335a9.4 9.4 0 0 1 2.255 1.027l-.919.622a8.2 8.2 0 0 0-1.828-.733A7.8 7.8 0 0 0 12 6Q8.675 6 6.338 8.338 4 10.675 4 14q0 1.05.287 2.075Q4.576 17.1 5.1 18h13.8a7.3 7.3 0 0 0 .838-1.975A8.5 8.5 0 0 0 20 13.9q0-.9-.232-1.894a6.6 6.6 0 0 0-.733-1.852l.623-.92q.73 1.252 1.033 2.357.303 1.103.309 2.298a9.3 9.3 0 0 1-.287 2.407 10 10 0 0 1-.91 2.254.9.9 0 0 1-.364.325A1.2 1.2 0 0 1 18.9 19H5.1q-.274 0-.51-.134a1.1 1.1 0 0 1-.394-.393 10.4 10.4 0 0 1-.846-1.974Q3 15.399 3 14q0-1.844.701-3.484a9.2 9.2 0 0 1 1.91-2.867A8.9 8.9 0 0 1 8.47 5.71 8.8 8.8 0 0 1 12 5"
  }))));
};
export default SvgRapid;